export enum KSEF_INTEGRATION_TYPE_ENUM {
  KSEF = 1,
  PKP = 2,
}
